import { baseColor, mobile, primaryColor, smallDesktop } from '../../../styles/general/theme';
import { css } from 'styled-components';
import { AbarthButtonStyle } from '../../button/abarth/abarth-button';

export const AbarthRichTextStyle = css<{
  standardPro?: boolean;
  disableOverflow?: boolean;
  overFlowWrap?: string;
}>`
  ${(p) =>
    p.disableOverflow &&
    css`
      overflow: hidden;
    `};

  ${(p) =>
    p.standardPro &&
    css`
      p {
        margin: 0;
      }
    `};

  @media (max-width: ${smallDesktop}px) {
    width: 100%;
  }

  img {
    max-width: 100%;
  }

  @media (max-width: ${mobile}px) {
    p {
      img {
        margin: 20px 0 !important;
        object-fit: cover;
        max-width: 100%;
      }
    }
  }

  em {
    font-style: italic;

    strong {
      font-style: italic;
    }
  }

  h2 span {
    font-weight: bold;
  }

  .richtext-tooltip {
    position: relative;
    cursor: pointer;
    font-size: 20px;
    margin: 0;
    color: ${baseColor(900)};
  }

  .primary-button {
    ${AbarthButtonStyle};
    display: inline-flex;
    cursor: not-allowed;
    border-color: ${baseColor(180)};
    color: ${baseColor(800)};
    background-color: ${baseColor(120)};
    box-shadow: none;

    :hover {
      color: ${baseColor(800)};
      background-color: ${baseColor(120)};
      border-color: ${baseColor(180)};
      box-shadow: none;
    }
  }

  .secondary-button {
    ${AbarthButtonStyle};
    display: inline-flex;
    cursor: not-allowed;
    border-color: ${baseColor(180)};
    color: ${baseColor(300)};
    background-color: ${baseColor(180)};
    box-shadow: none;

    :hover {
      color: ${baseColor(300)};
      background-color: ${baseColor(180)};
      border: 2px solid ${baseColor(180)};
      box-shadow: none;
    }

    .primary-link {
      color: ${baseColor(900)} !important;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;

      &:after {
        content: ' ';
        border-bottom: 2px solid ${baseColor(900)};
        display: inline-block;
        border-right: 2px solid ${baseColor(900)};
        transform: rotate(315deg);
        width: 5px;
        height: 5px;
        margin-bottom: 2px;
        margin-left: 10px;
      }

      &:hover {
        color: ${primaryColor(900)} !important;
        cursor: pointer;

        &:after {
          border-color: ${primaryColor(900)} !important;
        }
      }
    }

    .primary-link-left:before {
      content: ' ';
      width: 89px;
      border-bottom: 2px solid ${primaryColor(900)};
      display: block;
      margin-bottom: 12px;
      margin-top: 18px;
    }

    ${(p) =>
      p.standardPro &&
      css`
        html,
        body,
        div,
        span,
        applet,
        object,
        iframe,
        a,
        abbr,
        acronym,
        address,
        big,
        cite,
        code,
        del,
        dfn,
        em,
        font,
        img,
        ins,
        kbd,
        q,
        s,
        samp,
        small,
        strike,
        strong,
        sub,
        sup,
        tt,
        var,
        dl,
        dt,
        dd,
        li,
        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        pre,
        form,
        fieldset,
        input,
        textarea,
        label,
        legend,
        p,
        blockquote,
        table,
        caption,
        tbody,
        tfoot,
        thead,
        tr,
        th,
        td {
          all: revert;
        }

        p {
          margin: 0;
        }

        td {
          padding: 12px;
        }

        ul {
          padding-inline-start: revert !important;
          list-style-type: unset;
        }

        tbody {
          font-size: 14px;
          color: ${baseColor(900)};

          & tr {
            font-weight: 900;

            &:first-child {
              font-weight: 300;
              border-bottom: 1px solid ${baseColor(900)};
            }
          }
        }
      `};
  }
`;
